import SiteLayout from "@/components/SiteLayout";
import PageMeta from "@/components/PageMeta";

/**
 * Generic editorial container for the policy pages.
 * Pass `title` (string) and `children` (the body) when copy is provided.
 */
export default function PolicyPage({ title, children, meta }) {
  return (
    <SiteLayout>
      <PageMeta title={`${title} | Carlton Elleker Chase`} description={meta || title} />
      <section className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 pt-10 md:pt-20">
        <h1 className="h-display text-[clamp(2.4rem,6vw,5.4rem)] max-w-[18ch]">{title}</h1>
      </section>
      <section className="max-w-3xl mx-auto px-6 md:px-10 py-16 md:py-24">
        <div className="prose prose-cec text-graphite/85 leading-relaxed text-base md:text-lg [&_p]:mb-5 [&_h2]:mt-10 [&_h2]:mb-3 [&_h2]:text-2xl [&_h2]:font-semibold">
          {children}
        </div>
      </section>
    </SiteLayout>
  );
}
